/**
*
*   i18n Routing
*       - The Routing File
*
**/
import Config from '@/config';
import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting( Config.i18n );